import type { ReactNode } from "react";
import { Filter, RotateCcw } from "lucide-react";

import { Button, Select, TextField } from "../../components/ui/index.ts";

import styles from "./adhoc-email.module.css";

type Props = {
  employeeName: string;
  status?: string;
  busy?: boolean;
  showStatus?: boolean;
  onEmployeeChange: (value: string) => void;
  onStatusChange?: (value: string) => void;
  onApply: () => void;
  onClear: () => void;
  trailingActions?: ReactNode;
};

const STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "CONFIGURED", label: "Configured" },

];

export function AdhocEmailFilters({
  employeeName,
  status = "PENDING",
  busy = false,
  showStatus = true,
  onEmployeeChange,
  onStatusChange,
  onApply,
  onClear,
  trailingActions,
}: Props) {
  return (
    <div className={styles.filterGrid}>
      <TextField
        id="adhoc-employee-name-filter"
        label="Search Name"
        placeholder="Enter Name"
        value={employeeName}
        disabled={busy}
        onChange={(event) => onEmployeeChange(event.target.value)}
      />
      {showStatus ? (
        <Select
          label="Status"
          options={STATUS_OPTIONS}
          value={status}
          disabled={busy}
          onChange={(value) => onStatusChange?.(value)}
          placeholder="Select Status"
        />
      ) : null}
      <div className={styles.filterActions}>
        <Button variant="accent" startIcon={<Filter size={16} />} disabled={busy} onClick={onApply}>
          Apply Filter
        </Button>
        <Button variant="light-grey" startIcon={<RotateCcw size={16} />} disabled={busy} onClick={onClear}>
          Clear All
        </Button>
        {trailingActions}
      </div>
    </div>
  );
}
